import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  // Page pre-rendue : on reutilise le HTML existant (le texte reste affiche et compte pour le LCP).
  window.__hydrationErrors = [];
  ReactDOM.hydrateRoot(container, app, {
    onRecoverableError: (error) => {
      window.__hydrationErrors.push(String((error && error.message) || error).slice(0, 300));
      console.warn("Hydratation :", error);
    },
  });
} else {
  ReactDOM.createRoot(container).render(app);
}
